export default function WhatIsTeamBuilding() {
  return (
    <section id="what-is" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Что такое командообразование
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          <strong>Командообразование</strong> — это не одноразовый пикник или квест. Это системная работа по созданию среды, в которой сотрудники доверяют друг другу, открыто общаются, берут ответственность и работают на общий результат.
        </p>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Левая колонка — текст */}
          <div className="space-y-8">
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Почему это не «тимбилдинг ради развлечения»</h3>
              <p className="text-gray-600 leading-relaxed">
                Развлекательные мероприятия создают хорошее настроение на 1-2 дня. Но когда сотрудники возвращаются в офис, старые конфликты, барьеры и проблемы остаются на месте. <strong>Настоящее командообразование</strong> работает с причинами, а не с симптомами — оно меняет правила взаимодействия, культуру и отношения.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Как развивается команда</h3>
              <p className="text-gray-600 leading-relaxed">
                Команда проходит этапы: формирование, шторминг, нормализация и продуктивность. Без осознанной работы большинство команд застревает на этапе конфликтов. Командообразование помогает пройти эти этапы быстрее и эффективнее.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Какие задачи решает командообразование</h3>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-600 mt-1 flex-shrink-0"></i>
                  <span>Сплочение коллектива и развитие доверия</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-600 mt-1 flex-shrink-0"></i>
                  <span>Улучшение коммуникации между отделами</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-600 mt-1 flex-shrink-0"></i>
                  <span>Повышение вовлеченности и ответственности</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-600 mt-1 flex-shrink-0"></i>
                  <span>Снижение конфликтов и текучести</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-600 mt-1 flex-shrink-0"></i>
                  <span>Формирование корпоративной культуры</span>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Когда необходимо</h3>
              <p className="text-gray-600 leading-relaxed">
                Командообразование необходимо при росте компании, слиянии команд, смене руководителей, высокой текучести, низкой вовлеченности, конфликтах и при внедрении изменений.
              </p>
            </div>

            <div className="bg-teal-50 border border-teal-200 rounded-xl p-6">
              <p className="text-lg font-bold text-teal-800">
                Командообразование — это инвестиция, которая окупается ростом эффективности, снижением текучести и улучшением бизнес-показателей.
              </p>
            </div>
          </div>

          {/* Правая колонка — схема */}
          <div className="bg-white rounded-2xl p-8 border border-gray-200">
            <h3 className="text-xl font-bold text-gray-900 text-center mb-8">
              Путь от людей к результату бизнеса
            </h3>
            <div className="flex flex-col items-center gap-4">
              {[
                { label: 'Люди', desc: 'Набор специалистов', color: 'bg-gray-100 text-gray-700' },
                { label: 'Коммуникация', desc: 'Открытый обмен информацией', color: 'bg-teal-50 text-teal-800 border-teal-200' },
                { label: 'Доверие', desc: 'Готовность быть уязвимым и помогать', color: 'bg-teal-100 text-teal-800 border-teal-300' },
                { label: 'Ответственность', desc: 'Каждый отвечает за общий результат', color: 'bg-teal-200 text-teal-900 border-teal-400' },
                { label: 'Команда', desc: 'Единое целое больше суммы частей', color: 'bg-teal-300 text-teal-900 border-teal-500' },
                { label: 'Результат бизнеса', desc: 'Измеримый рост эффективности', color: 'bg-teal-600 text-white' },
              ].map((step, i, arr) => (
                <div key={i} className="w-full">
                  <div className={`${step.color} border rounded-xl p-4 text-center`}>
                    <div className="font-bold text-lg">{step.label}</div>
                    <div className="text-sm opacity-80 mt-1">{step.desc}</div>
                  </div>
                  {i < arr.length - 1 && (
                    <div className="flex justify-center my-2">
                      <i className="ri-arrow-down-line text-teal-500 text-xl"></i>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}